module.exports = vplayer;